import { useLoaderData } from '@remix-run/react'
import { useCallback, useState } from 'react'
import { ChatPage } from '#app/components/chat-page.js'
import { OnlyForMedicalAlert } from '#app/components/only-for-medical.js'
import { chatQueryLoader, generateUUID } from '#app/utils/chat-query.js'
import { useRegionParam } from '#app/utils/use-region-param.ts'

// Egen motor svarar alltid (IM-60), så regionvalet är alltid en riktig funktion
// och loadern behöver inte längre räkna ut något läge.
export const loader = chatQueryLoader

export default function ChatPageRoute() {
	const [conversationId, setConversationId] = useState(generateUUID)
	const { query: initialQuery } = useLoaderData<typeof loader>()
	// `query` lives in state (not directly from loader data) so we can null it
	// on reset. Without this, a user who deep-links via /?q=... and then clicks
	// "Ny konversation" would get the old query auto-submitted again on the
	// freshly-mounted ChatPage.
	const [query, setQuery] = useState(initialQuery)
	// Regionen kommer ur URL:en (?region=vgr) och delas med navbarens sökdialog.
	const { region, selectRegion: handleRegionSelect } =
		useRegionParam('assistant_region')

	const handleNewChat = useCallback(() => {
		setQuery(null)
		setConversationId(generateUUID())
	}, [])

	return (
		<div className="flex flex-1 flex-col overflow-hidden">
			<ChatPage
				key={conversationId}
				conversationId={conversationId}
				query={query}
				variant="full"
				onNewChat={handleNewChat}
				region={region}
				onSelectRegion={handleRegionSelect}
			/>
			{/* Bara startsidan; /embed täcks av huvudsidans egen ruta (IM-198). */}
			<OnlyForMedicalAlert />
		</div>
	)
}
